import { DefaultButton, PrimaryButton } from "@fluentui/react";
import Moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "../Hospital/hospital.module.css";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../constants/Constants";
import "./../../../src/constants/Columns/UserColumn.css";
import { useContext } from "react";
import userContext from "../../context/users/UserContext";
import { getEnv } from "../../helpers/EnvHelper";

const ColumnsProvider = (
  handleClickGroup,
  userId,
  roles,
  handleProviderClick,
  handleConnectProviderClick,
  handleLockButton,
  openPasswordReset
) => {
  const [t, i18n] = useTranslation();
  // const childTrPadding =
  //   getEnv("REACT_APP_HYBRID_MODE") == "false" ? "15px 5px" : "15px 10px";

  const childTrPadding = (getEnv("REACT_APP_HYBRID_MODE") == "false") ? "15px 0px 15px 10px" : "15px 10px";
  const rowTrPadding = "0px 10px";
  const{resetPasswordAllowed}=useContext(userContext);
  return [
    {
      id: "username",
      style: { width: "22%", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: { padding: "15px 0px 15px 10px", textAlign: "left", width: "23%", boxSizing:'border-box' },
      headerClass: "break-word",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Details</span>,
      accessor: "clients",
      accessorKey: "clients",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Name</div>
            <div className="user-sub-heading">{cell.row.original.name}</div>
          </div>

          {cell.row.original.type === "Radiologist" ? (
            <div className="user-mt-10">
              <div className="user-heading">Username</div>
              <div className="user-sub-heading">
                {cell.row.original.username}
              </div>
            </div>
          ) : (
            <div className="user-mt-10">
              <div className="user-heading">Address</div>
              <div className="user-sub-heading">
                {cell.row.original.address}
              </div>
            </div>
          )}
        </>
      ),
    },
    {
      id: "email",
      style: { width: "22%", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "23%",
        boxSizing: "border-box"
      },
      headerClass: "break-word",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Contact Details</span>,
      accessor: "email",
      accessorKey: "email",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">{t("user.email")}</div>
            <div className="user-sub-heading">{cell.row.original.email === "" ? '-' : cell.row.original.email}</div>
          </div>

          <div className="user-mt-10">
            <div className="user-heading">{t("user.mobile")}</div>
            <div className="user-sub-heading">{cell.row.original.mobileNo === "" ? "-" : cell.row.original.mobileNo}</div>
          </div>
        </>
      ),
    },
    {
      id: "Type",
      style: { width: "21%", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "23%",
        boxSizing:'border-box'
      },
      headerClass: "break-word",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Status</span>,
      accessor: "type",
      accessorKey: "type",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Type</div>
            <div className="user-sub-heading">{cell.row.original.type}</div>
          </div>

          <div className="user-mt-10">
            <div className="user-heading">Status</div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="user-sub-heading">
                {cell.row.original.status === "Active" ? (
                  <span className="active-green-dot"></span>
                ) : cell.row.original.status === "Inactive" ? (
                  <span className="inactive-red-dot"></span>
                ) : (
                  <span className="pending-orange-dot"></span>
                )}
                {cell.row.original.status}
              </div>
              {cell.row.original.status !== "Active" &&
                cell.row.original.status !== "Inactive" && (
                  <div style={{ marginLeft: "10px" }}>
                    <PrimaryButton
                      text={"Connect"}
                      //text={cell.row.values.action}
                      // onClick={(event) =>
                      //   handleClickGroup(event, cell.row.original.id, cell)
                      // }
                      onClick={(event) => {
                        event.stopPropagation();
                        handleConnectProviderClick(cell.row.original.type);
                      }}
                      style={{
                        width: "80px",
                        padding: "0",
                      }}
                    />
                  </div>
                )}
            </div>
          </div>
        </>
      ),
    },
    {
      id: "action",
      style: {
        width:"35%",
        display: "flex",
        height: "80px",
        alignItems: "center",
        boxSizing:'border-box',
        flexWrap: "nowrap"
      },
      headerClass: "break-word",
      classChildName: "break-word cursor-pointer",
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "31%",
      },
      header: () => <span>{t("supervisor.action")}</span>,
      accessor: "action",
      accessorKey: "action",
      show: true,
      cell: (cell) => (
        <>
          {cell.row.original.status === "Inactive" && (
            <PrimaryButton
              text={"Activate"}
              //text={cell.row.values.action}
              onClick={(event) =>
                handleClickGroup(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
              }}
            />
          )}
          {cell.row.original.status === "Active" && (
            <DefaultButton
              text={"Deactivate"}
              //text={cell.row.values.action}
              onClick={(event) =>
                handleClickGroup(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
              }}
            />
          )}
        
        {cell.row.original.type === "Radiologist" 
        && cell.row.original.countOfconnections <= 1 
        && (!cell.row.original.accountNonLocked ?<PrimaryButton
            text={ "Unlock"}
            //text={cell.row.values.action}
            onClick={(event) =>
              handleLockButton(event, cell.row.original.id, cell)
            }
            style={{
              width: "80px",
              padding: "0",
              marginLeft: "10px"
            }}
          />
          :
          <DefaultButton
          text={"Lock"}
          //text={cell.row.values.action}
          onClick={(event) =>
            handleLockButton(event, cell.row.original.id, cell)
          }
          style={{
            width: "80px",
            padding: "0",
            marginLeft: "10px"
          }}
        />)}
          {resetPasswordAllowed && cell.row.original.type === "Radiologist" && (
            <DefaultButton
              text="Reset Password"
              onClick={(event) => openPasswordReset(event, cell.row.original.name, cell.row.original.username)}
              styles={{ root: { minWidth: "120px", maxWidth: "100%", padding: 0, marginLeft: "10px" } }}
            />
          )}

        </>
      ),
    },
  ];
};
export default ColumnsProvider;
